import { connect } from 'react-redux'
import Settings from 'modules/Settings/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
